/** @format */

const CounterTranslations = {
  en: {
    'Counter.label': 'Destinations served',
    'Counter.label1': 'Qualified operators',
    'Counter.label2': 'Offered services',
    'Counter.label3': 'Registered citizens',
  },
  it: {
    'Counter.label': 'Destinazioni servite',
    'Counter.label1': 'Operatori qualificati',
    'Counter.label2': 'Servizi offerti',
    'Counter.label3': 'Cittadini iscritti',
  },
};

export default CounterTranslations;
